import { useEffect, useState } from 'react'
import { ApiError } from '../api/fetchJson'

let listeners: Array<() => void> = []

export function notifyAuthFailure() {
  listeners.forEach((fn) => fn())
}

export function ResetBanner() {
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    const fn = () => setVisible(true)
    listeners.push(fn)
    return () => {
      listeners = listeners.filter((l) => l !== fn)
    }
  }, [])
  if (!visible) return null
  return (
    <div className="bg-rebar-500/10 border-b border-rebar-500/40 px-4 py-2.5 flex items-center justify-center gap-3 flex-wrap">
      <span className="text-rebar-500 shrink-0 text-base leading-none">!</span>
      <span className="text-sm text-surface-100 text-center">
        The demo just reset. Please sign in again.
      </span>
      <button
        type="button"
        onClick={() => setVisible(false)}
        className="text-sm text-surface-400 underline hover:text-surface-100 shrink-0"
      >
        dismiss
      </button>
    </div>
  )
}

export function flagIfAuthError(err: unknown) {
  if (err instanceof ApiError && (err.status === 401 || err.status === 403)) {
    notifyAuthFailure()
  }
}
